// extracted by mini-css-extract-plugin
export default {"preferences":"column-preference-action_preferences__+ir3B"};